import cn from 'classnames'
import { useMemo } from 'react'

import { GrowField } from '../../../components/GrowField'
import { formatMoneyInteger } from '../../../helpers/formatMoneyInteger'
import { PERCENT_FRACTION_DIGITS } from '../../config'

import { IExtraRowsTotalProps } from './models/IExtraRowsTotalProps'

import styles from './ExtraConRowsTotal.module.scss'

interface IExtraConRowsTotalProps extends IExtraRowsTotalProps {
  isDistributorPlanner: boolean
  isShowPartnerCount: boolean
  isShowYoYPartnersVsPartners: boolean
  isShowQoQPartnersVsPartners: boolean

  isShowPlanAchievement: boolean

  partnerCount: number
  partnerCountPercent: number
  partnerCountYoY?: number
  partnerCountQoQ?: number

  yoyTargetsAch?: number
}

export const ExtraConRowsTotal = ({
  isPlanningByFY,
  sType,

  isDistributorPlanner,
  isShowPartnerCount,
  isShowYoYPartnersVsPartners,
  isShowQoQPartnersVsPartners,

  isShowYoYActualsVsActuals,
  isShowYoYActualsVsPlans,
  isShowYoYPlansVsPlans,

  isShowPlanAchievement,

  isShowQoQActualsVsActuals,
  isShowQoQActualsVsPlans,
  isShowQoQPlansVsPlans,

  partnerCount,
  partnerCountPercent,
  partnerCountYoY,
  partnerCountQoQ,

  yoyActuals,
  yoyTargets,
  yoyPlans,

  yoyTargetsAch,

  qoqActuals,
  qoqTargets,
  qoqPlans,
}: IExtraConRowsTotalProps) => {
  /** -------------------- Variables ----------------------- */

  const isShowAnyYoY = useMemo(() => {
    return isShowYoYActualsVsActuals || isShowYoYActualsVsPlans || isShowYoYPlansVsPlans
  }, [isShowYoYActualsVsActuals, isShowYoYActualsVsPlans, isShowYoYPlansVsPlans])

  const isShowAnyAchievement = useMemo(() => {
    return isShowPlanAchievement
  }, [isShowPlanAchievement])

  const isShowAnyQoQ = useMemo(() => {
    return isShowQoQActualsVsActuals || isShowQoQActualsVsPlans || isShowQoQPlansVsPlans
  }, [isShowQoQActualsVsActuals, isShowQoQActualsVsPlans, isShowQoQPlansVsPlans])

  const isShowAnyPartnerCount = useMemo(() => {
    return isDistributorPlanner && isShowPartnerCount
  }, [isDistributorPlanner, isShowPartnerCount])

  const isShowCountPercent = useMemo(() => {
    return isDistributorPlanner && isShowPartnerCount && !!sType
  }, [isDistributorPlanner, isShowPartnerCount, sType])

  const formattedPartnerCount = useMemo(() => {
    let formattedValue = '-'

    if (partnerCount) {
      formattedValue = formatMoneyInteger(partnerCount, 0, 1)
    }

    return formattedValue
  }, [partnerCount])

  /** -------------------- Render ----------------------- */

  return (
    <div>
      {isShowAnyPartnerCount && (
        <div className={styles.yoyBlock}>
          <div className={styles.actualsColor}>{formattedPartnerCount}</div>
          {isShowCountPercent && (
            <>
              {partnerCountPercent ? (
                <GrowField
                  percent={partnerCountPercent}
                  achiev
                  isNoColor
                  fractionDigits={PERCENT_FRACTION_DIGITS}
                />
              ) : (
                '-'
              )}
            </>
          )}
          {isShowYoYPartnersVsPartners && <div>{partnerCountYoY ? partnerCountYoY : '-'}</div>}
          {isShowQoQPartnersVsPartners && <div>{partnerCountQoQ ? partnerCountQoQ : '-'}</div>}
        </div>
      )}

      <div className={cn({ [styles.yoyBlock]: isShowAnyYoY })}>
        {isShowYoYActualsVsActuals && (
          <GrowField
            percent={yoyActuals}
            isPaleColor={true}
            fractionDigits={PERCENT_FRACTION_DIGITS}
          />
        )}
        {isShowYoYActualsVsPlans && (
          <GrowField percent={yoyTargets} fractionDigits={PERCENT_FRACTION_DIGITS} />
        )}
        {isShowYoYPlansVsPlans && (
          <GrowField percent={yoyPlans} fractionDigits={PERCENT_FRACTION_DIGITS} />
        )}
      </div>

      <div className={cn({ [styles.yoyBlock]: isShowAnyAchievement })}>
        {isShowPlanAchievement && (
          <GrowField percent={yoyTargetsAch} achiev fractionDigits={PERCENT_FRACTION_DIGITS} />
        )}
      </div>

      <div className={cn({ [styles.yoyBlock]: isShowAnyQoQ })}>
        {isPlanningByFY && (
          <div>
            {isShowQoQActualsVsActuals && <div>&nbsp;</div>}
            {isShowQoQActualsVsPlans && <div>&nbsp;</div>}
            {isShowQoQPlansVsPlans && <div>&nbsp;</div>}
          </div>
        )}
        {!isPlanningByFY && (
          <>
            {isShowQoQActualsVsActuals && (
              <GrowField
                percent={qoqActuals}
                isPaleColor={true}
                fractionDigits={PERCENT_FRACTION_DIGITS}
              />
            )}
            {isShowQoQActualsVsPlans && (
              <GrowField percent={qoqTargets} fractionDigits={PERCENT_FRACTION_DIGITS} />
            )}
            {isShowQoQPlansVsPlans && (
              <GrowField percent={qoqPlans} fractionDigits={PERCENT_FRACTION_DIGITS} />
            )}
          </>
        )}
      </div>
    </div>
  )
}
